/** @format */

export const PARENT_MESSAGES = Object.freeze({
  EXTRACT_SETTINGS: "extractSettings",
  SET_SETTINGS: "setSettings",
  GET_SETTINGS: "getSettings",
});

export const PARTNER_MESSAGES = Object.freeze({
  GET_SETTINGS: "getSettings",
  SET_SETTINGS: "setSettings",
});



// WEBPACK FOOTER //
// ./src/crawler/constants.js